import { useTranslation } from "react-i18next";
import React, { useState } from "react";

import {
  ChapterFlashCardsStatsDto,
  LessonFlashCardStatsDto,
} from "../../interfaces";
import { FlashCardStatisticsPage } from "./FlashCardStatisticsPage";
import { FlashCardPage } from "./FlashCardPage";

type TProps = { subjectId: string };
export const FlashCardLayoutPage: React.FC<TProps> = ({ subjectId }) => {
  //#region hooks
  const { t, i18n } = useTranslation();
  //#endregion

  //#region internal state
  const [page, setPage] = useState<number>(1);
  const [selectedChapterFlashCardsStats, setSelectedChapterFlashCardsStats] =
    useState<ChapterFlashCardsStatsDto | null>(null);
  const [selectedLessonFlashCardsStats, setSelectedLessonFlashCardsStats] =
    useState<LessonFlashCardStatsDto | null>(null);
  //#endregion

  document.title = `${t("documentTitle", { pageName: "flashCards" })}`;

  //#region handlers

  const onViewFlashCards = (
    chapter: ChapterFlashCardsStatsDto,
    lesson: LessonFlashCardStatsDto
  ) => {
    setPage(2);
    setSelectedChapterFlashCardsStats(chapter);
    setSelectedLessonFlashCardsStats(lesson);
  };
  //#endregion

  const getHeader = () => {
    try {
      return (
        <React.Fragment>
          <span className="cursor-pointer" onClick={() => setPage(1)}>
            {t("flashCards")}
          </span>
          {i18n.language === "ar" ? (
            <i className="ri-arrow-left-s-line align-bottom text-muted"></i>
          ) : (
            <i className="ri-arrow-right-s-line align-bottom text-muted"></i>
          )}
          <span className="text-muted">
            {i18n.language === "ar"
              ? selectedChapterFlashCardsStats?.name.ar
              : selectedChapterFlashCardsStats?.name.en}
          </span>
          {i18n.language === "ar" ? (
            <i className="ri-arrow-left-s-line align-bottom text-muted"></i>
          ) : (
            <i className="ri-arrow-right-s-line align-bottom text-muted"></i>
          )}
          <span className="text-muted">
            {i18n.language === "ar"
              ? selectedLessonFlashCardsStats?.name.ar
              : selectedLessonFlashCardsStats?.name.en}
          </span>
        </React.Fragment>
      );
    } catch (exception: any) {
      return t("flashCards");
    }
  };

  //#endregion

  return (
    <React.Fragment>
      {page === 1 && (
        <FlashCardStatisticsPage
          subjectId={subjectId}
          onViewFlashCards={onViewFlashCards}
        />
      )}
      {page === 2 && selectedLessonFlashCardsStats && (
        <FlashCardPage
          lessonId={selectedLessonFlashCardsStats?.id}
          header={getHeader()}
        />
      )}
    </React.Fragment>
  );
};
